import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChatStreamThoughtsSubscriptionVariables = Types.Exact<{
  chat_id?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ChatStreamThoughtsSubscription = { __typename?: 'subscription_root', chat_stream_thoughts: Array<{ __typename?: 'chat_stream_thoughts', id: number, chat_id: string, thought_content?: string | null, position: number, created_at?: any | null }> };


export const ChatStreamThoughtsDocument = gql`
    subscription chatStreamThoughts($chat_id: String) {
  chat_stream_thoughts(where: {chat_id: {_eq: $chat_id}}) {
    id
    chat_id
    thought_content
    position
    created_at
  }
}
    `;

/**
 * __useChatStreamThoughtsSubscription__
 *
 * To run a query within a React component, call `useChatStreamThoughtsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatStreamThoughtsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatStreamThoughtsSubscription({
 *   variables: {
 *      chat_id: // value for 'chat_id'
 *   },
 * });
 */
export function useChatStreamThoughtsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatStreamThoughtsSubscription, ChatStreamThoughtsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatStreamThoughtsSubscription, ChatStreamThoughtsSubscriptionVariables>(ChatStreamThoughtsDocument, options);
      }
export type ChatStreamThoughtsSubscriptionHookResult = ReturnType<typeof useChatStreamThoughtsSubscription>;
export type ChatStreamThoughtsSubscriptionResult = Apollo.SubscriptionResult<ChatStreamThoughtsSubscription>;